import { render } from "./chevron-down.vue?vue&type=template&id=2efe50b8"
import script from "./chevron-down.vue?vue&type=script&lang=js"
export * from "./chevron-down.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__